import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

const URL = "/staff/template_project_rooms/:id"

export default class extends Controller {

    connect() {
        this.sortable = Sortable.create(this.element, {
            onEnd: this.end.bind(this),
            animation: 150,
            handle: '.item-handle',
            group: {
                name: 'shared',
                put: 'shared'
            },
        })
    }

    end(event) {
        let templateProjectTemplateRoomContainer = event.item.closest('.template-project-template-room-container');
        if (templateProjectTemplateRoomContainer === null) return;
        let id = event.item.dataset.id;

        let data = new FormData();
        data.append('template_project_room[position]', event.newIndex + 1);

        Rails.ajax({
            url: URL.replace(':id',id),
            type: 'PATCH',
            data: data
        });
    }
}